module.exports = __webpack_public_path__ + "5502f1e5f48c200cff8598dda77229dd.svg";